import { AttributeId, Attributes, Filter, JobResult } from 'jobs.types';
import {
  RUBRIK_ATTRIBUTE_ID,
  THEMA_ATTRIBUTE_ID,
  ARBEITSORT_ATTRIBUTE_ID,
  STELLART_ATTRIBUTE_ID,
  BEFRISTUNG_ATTRIBUTE_ID,
  HOMEOFFICE_ATTRIBUTE_ID,
  HIERARCHY_ATTRIBUTE_ID,
} from '../constants';

const ATTRIBUTE_IDS: AttributeId[] = [
  RUBRIK_ATTRIBUTE_ID,
  THEMA_ATTRIBUTE_ID,
  ARBEITSORT_ATTRIBUTE_ID,
  STELLART_ATTRIBUTE_ID,
  BEFRISTUNG_ATTRIBUTE_ID,
];

const BOOLEAN_ATTRIBUTE_IDS: AttributeId[] = [HOMEOFFICE_ATTRIBUTE_ID];

const filterJobs = (
  jobs: JobResult[],
  attributes: Attributes,
  filter: Filter,
  setFilteredJobs: (jobs: JobResult[]) => void,
  filterJobIds: string[],
) => {
  if (!jobs?.length) return;

  let filteredJobs = [...jobs];

  if (filterJobIds && filterJobIds.length) {
    setFilteredJobs(
      filteredJobs
        .filter((job) => filterJobIds.includes(job.id))
        .sort((a, b) => filterJobIds.indexOf(a.id) - filterJobIds.indexOf(b.id)),
    );
    return;
  }

  if (filter.search.q) {
    filteredJobs = filteredJobs.filter((job) =>
      job.title.toLowerCase().includes(filter.search.q.toLowerCase()),
    );
  }

  if (!filteredJobs?.length) {
    setFilteredJobs([]);
    return;
  }

  ATTRIBUTE_IDS.forEach((attributeId) => {
    if (filter.search[attributeId] && filter.search[attributeId].length) {
      const translatedAttributes = filter.search[attributeId].map((id: string) => {
        return attributes[attributeId].values.find((value) => value.id === id)?.name;
      });

      filteredJobs = filteredJobs.filter((job) => {
        if (!job.attributes[attributeId]) return true;
        return job.attributes[attributeId]?.some((value) =>
          translatedAttributes.includes(value),
        );
      });
    }
  });

  if (
    filter.search[HIERARCHY_ATTRIBUTE_ID] &&
    filter.search[HIERARCHY_ATTRIBUTE_ID].length
  ) {
    filteredJobs = filteredJobs.filter((job) => {
      return filter.search[HIERARCHY_ATTRIBUTE_ID].includes(job[HIERARCHY_ATTRIBUTE_ID]);
    });
  }

  BOOLEAN_ATTRIBUTE_IDS.forEach((attributeId) => {
    if (filter.search[attributeId] && filter.search[attributeId].length) {
      filteredJobs = filteredJobs.filter((job) =>
        job.attributes[attributeId]?.some((value) =>
          filter.search[attributeId].includes(value),
        ),
      );
    }
  });

  if (filter.search['sza_pensum.min']) {
    filteredJobs = filteredJobs.filter((job) => {
      if (!job.szas['sza_pensum.max']) return true;
      return (
        parseInt(job.szas['sza_pensum.max'], 10) >=
        parseInt(filter.search['sza_pensum.min'], 10)
      );
    });
  }

  if (filter.search['sza_pensum.max']) {
    filteredJobs = filteredJobs.filter((job) => {
      if (!job.szas['sza_pensum.min']) return true;
      return (
        parseInt(job.szas['sza_pensum.min'], 10) <=
        parseInt(filter.search['sza_pensum.max'], 10)
      );
    });
  }

  if (!filteredJobs?.length) {
    setFilteredJobs([]);
    return;
  }

  setFilteredJobs(filteredJobs);
};

export default filterJobs;
